const HotspotContent = {
  parts: [
    'container',
    'authorImage',
    'authorInfo',
    'authorName',
    'authorTitle',
    'arrowIcon'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      width: '212px',
      px: 2,
      py: 3.5,
      alignItems: 'center',
      gap: '2',
      bg: 'white',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      position: 'absolute',
      bottom: '100%',
      left: '-17px',
      marginBottom: 3.5,
      _hover: {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 25px rgba(0, 0, 0, 0.15)',
      },
    },
    authorImage: {
      width: '11',
      height: '11',
      borderRadius: 'full',
      flexShrink: 0,
      objectFit: 'cover',
    },
    authorInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '0.5',
      flex: '1 0 0',
    },
    authorName: {
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: 'md',
      fontWeight: '500',
      lineHeight: '120%',
      alignSelf: 'stretch',
    },
    authorTitle: {
      color: 'brandColors.greyscale70',
      fontFamily: 'heading',
      fontSize: 'xs',
      fontWeight: '400',
      lineHeight: '120%',
      alignSelf: 'stretch',
    },
    arrowIcon: {
      width: 3.5,
      height: 3.5,
      color: 'brandColors.primaryDarkLinen',
      flexShrink: 0,
      display: 'flex',
      sx: {
        ' svg': {
          width: 'full',
          height: 'full',
        },
      },
    },
  },
};

export default HotspotContent;
